import { IState } from '../../store';

export const selectIsUserSubscribedToPriceChange = (state: IState): boolean => {
  return state.offerData.subscription?.isSubscribed || false;
};
